import { get } from "app/utils/axios/kheti";
import { CreditResponse } from "../models/credit";
import ToastAndroid from "app/mocks/ToastAndroid";

const fetchFarmerCreditDetails = async (farmerId: string) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/credit`;
    const response = await get<CreditResponse>(url);
    return response;
  } catch (e) {
    ToastAndroid.show("Failed to fetch credit details.", ToastAndroid.SHORT);
    return null;
  }
};

export default fetchFarmerCreditDetails;
